/**
 * Created by renming on 2017/6/28.
 */
import { getQueryString } from "../../util/tools"
const state = {
    // 用户登录信息
    userInfo: {},
    //当前皮肤
    skin: localStorage.getItem('SKIN'),
    // 未读消息数
    unreadMsg:0,
    // 未处理警情数
    unHandleMsg:0,
};

const actions = {
    /* 用户登录成功 */
    setUserInfo({ commit }, res) {
        commit("setUserInfo", res);
    },
    setUnreadMsg({ commit }, res) {
        commit("setUnreadMsg", res);
    },
    resetUnreadMsg({ commit }, res) {
        commit("resetUnreadMsg", res);
    },
    setUnHandleMsg({ commit }, res) {
        commit("setUnHandleMsg", res);
    },
    resetUnHandleMsg({ commit }, res) {
        commit("resetUnHandleMsg", res);
    },
};

const mutations = {
    setUserInfo(state, res) {
        state.userInfo = res;
    },
    /* 更新未读消息数 */
    setUnreadMsg(state, res){
        state.unreadMsg = res;
    },
    resetUnreadMsg(state, res){
        state.unreadMsg = 0;
    },
    /* 更新未处理警情数 */
    setUnHandleMsg(state, res){
        state.unHandleMsg = res;
    },
    resetUnHandleMsg(state, res){
        state.unHandleMsg = 0;
    },
};

const getters = {
    getUserInfo: state => state.userInfo,
    getUnreadMsg: state => state.unreadMsg,
    getUnHandleMsg: state => state.unHandleMsg,
};


export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/vuex/modules/user.js